import * as Yup from 'yup'

const userEditorSchema = Yup.object().shape({
  name: Yup.string().required(`User's name is required`),
  roleIds: Yup.array()
    .of(Yup.string())
    .min(1, `At least one user role is required`)
    .required(`User roles are required`),
  email: Yup.string()
    .email('Email is not valid')
    .required(`User's email address is required`),
})

export default userEditorSchema
